// extracted by mini-css-extract-plugin
module.exports = {"MainAndAside":"MainAndAside_MainAndAside__TXc2f","Main":"MainAndAside_Main__1vMeo","Aside":"MainAndAside_Aside__3ThCA"};